/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type ConversationUserActionFilterConfigColumn =
  (typeof ConversationUserActionFilterConfigColumn)[keyof typeof ConversationUserActionFilterConfigColumn];

export const ConversationUserActionFilterConfigColumn = {
  conversation_user_action: 'conversation_user_action',
} as const;
